(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-information-content"] && !Shopify.designMode) return;
  try {
    if (!window.__productMediaArrowNavInitialized) {
    window.__productMediaArrowNavInitialized = true;

    const getCurrentMediaIndex = (gallery, items) => {
      const currentScrollTop = gallery.scrollTop;
      const snapTolerance = 8;
      const exactIndex = items.findIndex((item) => Math.abs(item.offsetTop - currentScrollTop) <= snapTolerance);

      if (exactIndex >= 0) return exactIndex;

      let nearestIndex = 0;
      let nearestDistance = Number.POSITIVE_INFINITY;

      items.forEach((item, index) => {
        const distance = Math.abs(item.offsetTop - currentScrollTop);

        if (distance < nearestDistance) {
          nearestDistance = distance;
          nearestIndex = index;
        }
      });

      return nearestIndex;
    };

    const getMediaNavButton = (target) => {
      if (!(target instanceof Element)) return null;
      return target.closest('.media-nav-button');
    };

    document.addEventListener(
      'pointerdown',
      (event) => {
        const button = getMediaNavButton(event.target);
        if (!button) return;

        event.stopPropagation();
        event.stopImmediatePropagation();
      },
      true,
    );

    document.addEventListener(
      'click',
      (event) => {
        const button = getMediaNavButton(event.target);
        if (!button) return;

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        button.setAttribute('type', 'button');

        const mediaContainer = button.closest('.product-information__media');
        const gallery = mediaContainer?.querySelector('media-gallery.media-gallery--grid');
        const grid = gallery?.querySelector('.media-gallery__grid');
        const items = grid ? Array.from(grid.children) : [];

        if (!gallery || items.length < 2) return;

        const currentIndex = getCurrentMediaIndex(gallery, items);
        const isMovingDown = button.dataset.direction === 'down';
        const nextIndex = Math.max(0, Math.min(items.length - 1, currentIndex + (isMovingDown ? 1 : -1)));

        if (nextIndex === currentIndex) return;

        gallery.scrollTo({
          top: items[nextIndex].offsetTop,
          behavior: 'smooth',
        });
      },
      true,
    );
  }
  } catch(e) { console.error(e); }
})();

})();
